export default __webpack_public_path__ + "static/media/profile.ccdc6d18.jpg";